import { render, staticRenderFns } from "./Clarification.vue?vue&type=template&id=143b6574&scoped=true&"
import script from "./Clarification.vue?vue&type=script&lang=js&"
export * from "./Clarification.vue?vue&type=script&lang=js&"
import style0 from "./Clarification.vue?vue&type=style&index=0&id=143b6574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143b6574",
  null
  
)

export default component.exports